'use client';

import * as React from 'react';

/**
 * Marca MakeStudio — logo + wordmark com o gradiente da marca (roxo → laranja).
 * Use `lg` em telas de entrada (PreJoin) e `sm` no canto da sala. A marca tem que
 * aparecer em tudo.
 */
export function Brand({
  size = 'lg',
  style,
}: {
  size?: 'lg' | 'sm';
  style?: React.CSSProperties;
}) {
  const h = size === 'lg' ? 52 : 26;
  const fs = size === 'lg' ? 24 : 15;
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: size === 'lg' ? 12 : 8,
        userSelect: 'none',
        ...style,
      }}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src="/images/makestudio-logo.png"
        alt="MakeStudio"
        style={{ height: h, width: 'auto', filter: 'drop-shadow(0 4px 14px rgba(120,90,255,0.28))' }}
      />
      <span
        style={{
          fontSize: fs,
          fontWeight: 800,
          letterSpacing: '-0.02em',
          backgroundImage: 'linear-gradient(90deg, #9a8bff, #ff8a3d)',
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
          color: 'transparent',
          whiteSpace: 'nowrap',
        }}
      >
        MakeStudio
      </span>
    </div>
  );
}
